var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"mealsModal",attrs:{"id":"mealsModal","title":_vm.$t('message.mealsModal.title'),"visible":_vm.visible,"hide-header-close":"","hide-footer":""},on:{"hidden":_vm.hide,"shown":function($event){return _vm.focusOnSearch()}}},[_c('Meals',{attrs:{"meals":_vm.meals,"chosen-meal":_vm.chosenMeal},on:{"input":_vm.mealChosen}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }